import { Directive } from '@angular/core';

@Directive({ selector: '[uxg-user-profile-panel-details], [uxgUserProfilePanelDetails]' })
export class UxgUserProfilePanelDetailsDirective {
  constructor() {}
}
